<tilby-dialog-toolbar mat-dialog-title
    [title]="title"
    [hideConfirm]="!selectedOrder"
    (confirm)="confirm()" />
@if(message) {
    <div class="tw-flex tw-justify-center tw-py-4" (click)="clearMessage()">
        <span>{{message | translate}}</span>
    </div>
}
@if(operationInProgress()) {
    <tilby-dialog-progress-bar />
}
<tilby-dialog-content>
    @if(loginForm) {
        <form [formGroup]="loginForm" (ngSubmit)="onLogin()" class="tw-flex tw-flex-col">
            <mat-form-field appearance="fill">
                <mat-label>{{'CASHREGISTER.MAGO_ORDERS.TYPE' | translate}}</mat-label>
                <mat-select formControlName="appId" required>
                    <mat-option value="magoCloud">{{'CASHREGISTER.MAGO_ORDERS.TYPE_MAGO_CLOUD' | translate}}</mat-option>
                    <mat-option value="magoWeb">{{'CASHREGISTER.MAGO_ORDERS.TYPE_MAGO_WEB' | translate}}</mat-option>
                    <mat-option value="mago4">{{'CASHREGISTER.MAGO_ORDERS.TYPE_MAGO_4' | translate}}</mat-option>
                </mat-select>
                @if(loginForm.get('type')?.hasError('required')) {
                    <mat-error class="tw-pt-2">{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                }
            </mat-form-field>
            <mat-form-field appearance="fill">
                <mat-label>{{'CASHREGISTER.MAGO_ORDERS.ACCOUNT_NAME' | translate}}</mat-label>
                <input matInput type="text" formControlName="accountName" required>
                @if(loginForm.get('accountName')?.hasError('required')) {
                    <mat-error class="tw-pt-2">{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                }
            </mat-form-field>
            <mat-form-field appearance="fill">
                <mat-label>{{'CASHREGISTER.MAGO_ORDERS.PASSWORD' | translate}}</mat-label>
                <input matInput type="password" formControlName="password" required>
                @if(loginForm.get('password')?.hasError('required')) {
                    <mat-error class="tw-pt-2">{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                }
            </mat-form-field>
            @if(loginForm.get('appId')?.value === 'mago4') {
                <mat-form-field appearance="fill">
                    <mat-label>{{'CASHREGISTER.MAGO_ORDERS.COMPANY' | translate}}</mat-label>
                    <input matInput type="text" formControlName="company" required>
                    @if(loginForm.get('company')?.hasError('required')) {
                        <mat-error class="tw-pt-2">{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                    }
                </mat-form-field>
            } @else {
                <mat-form-field appearance="fill">
                    <mat-label>{{'CASHREGISTER.MAGO_ORDERS.SUBSCRIPTION_KEY' | translate}}</mat-label>
                    <input matInput type="text" formControlName="subscriptionKey" required>
                    @if(loginForm.hasError('required', ['subscriptionKey'])) {
                        <mat-error class="tw-pt-2">{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                    }
                </mat-form-field>
            }
            @if(loginForm.get('appId')?.value === 'magoWeb' || loginForm.get('appId')?.value === 'mago4') {
                <mat-form-field appearance="fill">
                    <mat-label>{{'CASHREGISTER.MAGO_ORDERS.SERVER_ADDRESS' | translate}}</mat-label>
                    <input matInput type="text" formControlName="espBackend" required>
                    @if(loginForm.get('espBackend')?.hasError('required')) {
                        <mat-error class="tw-pt-2">{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                    }
                </mat-form-field>
            }
            <div class="tw-flex tw-justify-center">
                <button mat-raised-button color="primary" type="submit" [disabled]="!loginForm.valid">
                    {{'CASHREGISTER.MAGO_ORDERS.SAVE_CREDENTIALS_ACTION' | translate}}
                </button>
            </div>
        </form>
    } @else if(ordersForm) {
        <form [formGroup]="ordersForm" class="tw-flex tw-flex-col">
            <div class="tw-flex tw-flex-col md:tw-flex-row md:tw-space-x-1">
                <!-- Customer Order Search -->
                <mat-form-field appearance="fill" class="tw-flex-grow">
                    <mat-label>{{'CASHREGISTER.MAGO_ORDERS.CUSTOMER' | translate}}</mat-label>
                    <input matInput formControlName="customer" [matAutocomplete]="customerAutocomplete">
                    <mat-autocomplete #customerAutocomplete="matAutocomplete" [displayWith]="displayCustomerName" (optionSelected)="customerSelected($event)">
                        @for(customer of filteredCustomers | async; track customer.uuid) {
                            <mat-option [value]="customer">{{ displayCustomerName(customer) }}</mat-option>
                        }
                    </mat-autocomplete>
                </mat-form-field>
            </div>

            <button mat-raised-button color="primary"
                (click)="searchOrders()"
                [disabled]="!selectedCustomer">
                {{'CASHREGISTER.MAGO_ORDERS.SEARCH_ACTION' | translate}}
            </button>

            <!-- Orders List -->
            @if(ordersList) {
                @if(ordersList.length) {
                    <mat-selection-list class="tw-mt-4 tw-max-h-[400px] tw-overflow-y-auto" [multiple]="false" (selectionChange)="onOrderSelect($event)">
                        @for(order of ordersList; track order) {
                            <mat-list-option [value]="order">
                                <div class="tw-flex tw-flex-col tw-w-full">
                                    <div class="tw-flex tw-justify-between tw-items-center">
                                        <span class="tw-font-medium">{{ 'CASHREGISTER.MAGO_ORDERS.ORDER' | translate}} {{order.InternalOrdNo}}</span>
                                        <span>{{order.OrderDate | tilbyDate : 'dd/MM/yyyy'}}</span>
                                    </div>
                                    <div class="tw-flex tw-justify-between tw-items-center tw-text-sm">
                                        <span>{{order.TotalAmount | tilbyCurrency}}</span>
                                    </div>
                                </div>
                            </mat-list-option>
                            <mat-divider />
                        }
                    </mat-selection-list>
                } @else {
                    <div class="tw-flex tw-justify-center tw-items-center tw-p-4 tw-text-gray-500">
                        {{'CASHREGISTER.MAGO_ORDERS.NO_ORDERS' | translate}}
                    </div>
                }
            }
        </form>
    } @else if(stockForm) {
        <form [formGroup]="stockForm" class="tw-flex tw-flex-col">
            <mat-form-field appearance="fill">
                <mat-label>{{'CASHREGISTER.MAGO_ORDERS.STOCK.SKU' | translate}}</mat-label>
                <input matInput type="text" formControlName="itemCode" required>
                @if(stockForm.get('itemCode')?.hasError('required')) {
                    <mat-error class="tw-pt-2">{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                }
            </mat-form-field>
            <mat-form-field appearance="fill">
                <mat-label>{{'CASHREGISTER.MAGO_ORDERS.STOCK.SHOP_TYPE' | translate}}</mat-label>
                <mat-select formControlName="shopType" required>
                    <mat-option value="AllOnSiteShops">{{'CASHREGISTER.MAGO_ORDERS.STOCK.ALL_SHOPS' | translate}}</mat-option>
                    <mat-option value="OnlyOneShop">{{'CASHREGISTER.MAGO_ORDERS.STOCK.ONLY_ONE_SHOP' | translate}}</mat-option>
                </mat-select>
                @if(stockForm.get('shopType')?.hasError('required')) {
                    <mat-error class="tw-pt-2">{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                }
            </mat-form-field>
            <button mat-raised-button color="primary" (click)="searchStock()" [disabled]="!stockForm.valid">
                {{'CASHREGISTER.MAGO_ORDERS.SEARCH_ACTION' | translate}}
            </button>
            @if(stockList) {
                @if(stockList.length) {
                    <div class="mat-elevation-z2 tw-mt-4 tw-max-h-[400px] tw-overflow-y-auto">
                        <table mat-table [dataSource]="stockList" class="tw-w-full">
                            <!-- FiscalYear Column -->
                            <ng-container matColumnDef="fiscalYear">
                                <th mat-header-cell *matHeaderCellDef>{{'CASHREGISTER.MAGO_ORDERS.STOCK.FISCAL_YEAR' | translate}}</th>
                                <td mat-cell *matCellDef="let element"> {{element.fiscalYear}} </td>
                            </ng-container>
                            <!-- Name Column -->
                            <ng-container matColumnDef="name">
                                <th mat-header-cell *matHeaderCellDef>{{'CASHREGISTER.MAGO_ORDERS.STOCK.NAME' | translate}}</th>
                                <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                            </ng-container>
                            <!-- Shop Column -->
                            <ng-container matColumnDef="shopDescription">
                                <th mat-header-cell *matHeaderCellDef>{{'CASHREGISTER.MAGO_ORDERS.STOCK.SHOP' | translate}}</th>
                                <td mat-cell *matCellDef="let element"> {{element.shopDescription}} </td>
                            </ng-container>
                            <!-- Storage Column -->
                            <ng-container matColumnDef="storageDescription">
                                <th mat-header-cell *matHeaderCellDef>{{'CASHREGISTER.MAGO_ORDERS.STOCK.STORAGE' | translate}}</th>
                                <td mat-cell *matCellDef="let element"> {{element.storageDescription}} </td>
                            </ng-container>
                            <!-- VariantCode Column -->
                            <ng-container matColumnDef="variantCode">
                                <th mat-header-cell *matHeaderCellDef>{{'CASHREGISTER.MAGO_ORDERS.STOCK.VARIANT_CODE' | translate}}</th>
                                <td mat-cell *matCellDef="let element"> {{element.variantCode}} </td>
                            </ng-container>
                            <!-- FinalOnHand Column -->
                            <ng-container matColumnDef="finalOnHand">
                                <th mat-header-cell *matHeaderCellDef>{{'CASHREGISTER.MAGO_ORDERS.STOCK.FINAL_ON_HAND' | translate}}</th>
                                <td mat-cell *matCellDef="let element"> {{element.finalOnHand}} </td>
                            </ng-container>
                            <ng-container matColumnDef="reservedSaleOrd">
                                <th mat-header-cell *matHeaderCellDef>{{'CASHREGISTER.MAGO_ORDERS.STOCK.RESERVED' | translate}}</th>
                                <td mat-cell *matCellDef="let element"> {{element.reservedSaleOrd}} </td>
                            </ng-container>
                            <ng-container matColumnDef="available">
                                <th mat-header-cell *matHeaderCellDef>{{'CASHREGISTER.MAGO_ORDERS.STOCK.AVAILABLE' | translate}}</th>
                                <td mat-cell *matCellDef="let element"> {{element.available}} </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedStockColumns; sticky: true"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedStockColumns;"></tr>
                        </table>
                    </div>
                }
            }
        </form>
    }
</tilby-dialog-content>